var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{staticClass:"font-weight-bold px-2",attrs:{"label":"","x-small":"","color":_vm.getColorWithLighten(_vm.params.status),"text-color":_vm.getColorWithDarken(_vm.params.status)}},[_vm._v(" "+_vm._s(_vm.params.status)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }